import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import get from 'lodash.get';

const selectWorksheetPages = createDeepEqualSelector(
    selectWorksheet,
    (worksheetState) => get(worksheetState, ['pages'])
);

const makeSelectWorksheetPages = (): typeof selectWorksheetPages =>
    selectWorksheetPages;

export { makeSelectWorksheetPages };
